export enum UserType {
  Student = 1,
  Company = 2,
  Admin = 3,
}
